import { render, staticRenderFns } from "./modal-downloads-pricelist-consent.vue?vue&type=template&id=06300005&"
import script from "./modal-downloads-pricelist-consent.vue?vue&type=script&lang=js&"
export * from "./modal-downloads-pricelist-consent.vue?vue&type=script&lang=js&"
import style0 from "./modal-downloads-pricelist-consent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports